"use client"
import IconSearch from "@/app/(site)/_components/Atoms/Icons/IconSearch"
import { getLangCode } from "@/app/(site)/_utils/misc"
import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import { t } from "@/translations"
import React from "react"

type SearchButtonProps = {
    locale: string
}

const SearchButton: React.FC<SearchButtonProps> = ({ locale }) => {
    const langCode = getLangCode(locale) ?? "en"
    const toggleSearchModal = useEcommerceStore(state => state.toggleSearchModal)
    return (
        <button
            aria-label={t(langCode, "Open Search")}
            className="flex items-center px-14 py-18"
            onClick={() => toggleSearchModal(true)}
        >
            <IconSearch className="" />
        </button>
    )
}

export default SearchButton
